module.exports = __webpack_public_path__ + "static/protocol-0bef80c8088a35ff56caa541f6bd1673.png";